<template>
    <div class="web-modal" v-drag="'.web-modal-header'">
        <div class="web-modal-header">
            <div class="left">
                <img class="logo"
                    src="https://feat-sit-dndcfenge-node-assets.nissan-website.dev.dndc.cloud/image/common/logo/logo2.png"
                    draggable="false" />
                <span class="title">{{ title }}</span>
            </div>
            <span class="close" @click="onClose">✕</span>
        </div>

        <div class="web-modal-body">
                <iframe v-if="url" :src="url" frameborder="0" title="web-modal-iframe" />
        </div>
    </div>
</template>

<script>

export default {
    name: 'MRebot',
    data(){
        return{

        }
    },
    props: {
        title: {
            type: String,
            default: '在线客服'
        },
        url: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        onClose: {
            type: Function,
            required: true
        },
        url:{
            type:String,
            default:''
        }
    },
    methods: {
        
    },
    async mounted() {
        
    },
    directives: {
        drag: {
            bind(el, binding) {
                const header = el.querySelector(binding.value)
                if (!header) return

                header.style.cursor = 'move'

                let startX = 0
                let startY = 0
                let initX = 0
                let initY = 0

                header.onmousedown = (e) => {
                    startX = e.clientX
                    startY = e.clientY

                    const rect = el.getBoundingClientRect()
                    initX = rect.left
                    initY = rect.top

                    document.onmousemove = (e) => {
                        const dx = e.clientX - startX
                        const dy = e.clientY - startY

                        el.style.position = 'fixed'
                        el.style.left = initX + dx + 'PX'
                        el.style.top = initY + dy + 'PX'
                    }

                    document.onmouseup = () => {
                        document.onmousemove = null
                        document.onmouseup = null
                    }
                }
            }
        }
    }
}
</script>

<style scoped>
.web-modal {
    width: 100%;
    height:100%;
    background: #fff;
    border-radius: 6PX;
    box-shadow: 0 4PX 12PX rgba(0, 0, 0, 0.15);
    overflow: hidden;
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
}

.web-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10PX 12PX;
    background: #f5f5f5;
    border-bottom: 1PX solid #e8e8e8;
}

.left {
    display: flex;
    align-items: center;
}

.logo {
    width: 22PX;
    height: 22PX;
    margin-right: 8PX;
}

.title {
    font-size: 14PX;
    font-weight: 500;
    color: #333;
}

.close {
    cursor: pointer;
    font-size: 16PX;
    color: #999;
}

.close:hover {
    color: #333;
}

.web-modal-body {
    flex:1;
}

.web-modal-body iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>
